import React, { useMemo } from 'react'
import { useEffectOnce } from '@chilecompra/react-kit'
import { useSelector, useDispatch } from 'react-redux'
import { onGetNotificationsConfigThunk } from './Notifications.actions'
import { Toast } from '@chilecompra/react-kit/components'
import {
  NOTIFICATIONS_FETCH_CONTROL_TIME_MILLIS as FETCH_CONTROL,
  NOTIFICATIONS_BUYER,
  NOTIFICATIONS_BUYER_TYPE,
  NOTIFICATIONS_ORIGIN_PRE_SELECTOR_CODE,
  NOTIFICATIONS_ORIGIN_SELECTOR_CODE
} from '../../config/settings/constants'
import { useAuthorization } from '../AuthProvider/AuthProvider.hooks'

/**
  Notification's Container
  list app level notifications/alerts
*/
const Notifications = () => {
  const dispatch = useDispatch()
  const { notifications, lastFetch } = useSelector(state => state.notifications)
  const { isBuyer } = useAuthorization()

  useEffectOnce(() => {
    if (!lastFetch || Date.now() - lastFetch > FETCH_CONTROL) {
      dispatch(onGetNotificationsConfigThunk())
    }
  })

  const userTypeNotification = useMemo(() => {
    if (isBuyer) {
      const posteriorConfig = notifications.find(
        n => n.tipo === NOTIFICATIONS_BUYER_TYPE && n.codigo === NOTIFICATIONS_ORIGIN_SELECTOR_CODE
      )
      let shouldShowPosterior = false
      if (posteriorConfig) {
        const serverTime = new Date(posteriorConfig.horaServidor)
        const inicioDate = new Date(posteriorConfig.inicio)
        const expiracionDate = new Date(posteriorConfig.expiracion)
        if (serverTime >= inicioDate && serverTime <= expiracionDate) {
          shouldShowPosterior = true
        }
      }

      return NOTIFICATIONS_BUYER.filter(item => {
        if (shouldShowPosterior && item.code === NOTIFICATIONS_ORIGIN_PRE_SELECTOR_CODE) {
          return false
        }
        const notificationConfig = notifications.find(
          n => n.tipo === NOTIFICATIONS_BUYER_TYPE && n.codigo === item.code
        )
        if (!notificationConfig) return false
        const serverTime = new Date(notificationConfig.horaServidor)
        const inicioDate = new Date(notificationConfig.inicio)
        const expiracionDate = new Date(notificationConfig.expiracion)
        return serverTime >= inicioDate && serverTime <= expiracionDate
      })
    }
    return []
  }, [isBuyer, notifications])

  if (!userTypeNotification?.length) return null

  return (
    <>
      {userTypeNotification?.map((n, i) => (
        <Toast key={i} title={n.title} severity={n.type} textDirection="vertical" margin="12px 0">
          {n.content}
        </Toast>
      ))}
    </>
  )
}

export default Notifications
